<template lang="pug" functional>
  .blank-item-skeleton
    v-card.blank-item-skeleton__item(
      v-for="i in props.count"
      :key="i")
      .blank-item-skeleton__loader
      .blank-item-skeleton__loader
      .blank-item-skeleton__loader
</template>

<script>
export default {
  name: 'BlankItemSkeleton',

  props: {
    count: {
      type: Number,
      default: 7
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/sass/abstracts/_mixins.scss';

  .blank-item-skeleton {
    margin-top: 1rem;
    
    &__item {
      height: 4.5rem;
      margin-bottom: 1rem;
      padding: 1rem 2rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    &__loader {
      height: 2.5rem;
      border-radius: .8rem;

      &:first-child {
        width: 14.5rem;
      }

      &:nth-child(2) {
        width: 11.4rem;
      }

      &:last-child {
        width: 3.2rem;
      }

      @include skeleton;
    }
  }
</style>
